module.exports = new __parcel__URL__("Mariam_Sumbadze.963793f6.jpg").toString();